import { useCallback, useMemo, useState } from 'react';

import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';

import { useLocationTimezone } from '../../../hooks/useLocationTimezone/useLocationTimezone';
import { USADateFormatShort, USATimeFormatAmPm } from '../../../utils';
import { useTaskViewActivitiesStyles } from './assets';
import { TaskViewActivitiesProps } from './model';
import { ActivityCard, ViewSection } from './ui';

export const TaskViewActivities = ({ timeZone, watch }: TaskViewActivitiesProps) => {
  const styles = useTaskViewActivitiesStyles();

  const { utcToZone } = useLocationTimezone(timeZone);

  const [isShowActivities, setIsShowActivities] = useState(false);

  const activities = watch('activities');

  const activitiesForDisplay = useMemo(
    () => activities.filter(activity => activity.showInTaskActivityList === '1'),
    [activities],
  );

  const buttonText = useMemo(() => (isShowActivities ? 'Hide' : 'View') + ' activity records', [isShowActivities]);

  const toggleList = useCallback(() => {
    setIsShowActivities(state => !state);
  }, []);

  return (
    <ViewSection
      title="Activity"
      button={{
        title: buttonText,
        onClick: toggleList,
      }}
    >
      <Collapse in={isShowActivities}>
        {activitiesForDisplay.length ? (
          <div className={styles.activitiesList}>
            {activitiesForDisplay.map(activity => (
              <ActivityCard
                key={activity.id}
                details={activity.description}
                createdBy={activity.created}
                createdDate={
                  utcToZone(
                    activity.created.datetime,
                    'string',
                    `${USADateFormatShort} ${USATimeFormatAmPm.toLowerCase()}`,
                  ) as string
                }
              />
            ))}
          </div>
        ) : (
          <Typography>No activity found</Typography>
        )}
      </Collapse>
    </ViewSection>
  );
};
